import React from 'react';
import Api from "../../servicios/api";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faTimes, faArrowRight, faAngleDoubleLeft, faAngleLeft, faAngleDoubleRight, faAngleRight } from '@fortawesome/free-solid-svg-icons';

class Enfermedades1 extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            datosCargados: false,
            pagina: [],
            enfermedades1: []
        };
    }
    
    resetForm() {
        document.getElementById('bdescripcion1').value = "";
        document.getElementById('bcodigo1').value = "";
        document.getElementById('bdescripcion1').focus();
        this.BuscarEnf2(1);
    }
    
    componentDidMount() {
        this.BuscarEnf2(1);
    }
    
    BuscarEnf2(page) {
        let bdescripcion1 = document.getElementById('bdescripcion1').value;
        let bcodigo1 = document.getElementById('bcodigo1').value;
        
        if (bdescripcion1 == '') {
            bdescripcion1 = 0;
        }
        if (bcodigo1 == '') {
            bcodigo1 = 0;
        }
        
        fetch(Api + "SearchEnfermedades/" + bcodigo1 + "/" + bdescripcion1 + "?page=" + page)
            .then((respuesta) => respuesta.json())
            .then((datosRespuesta) => {
                this.setState({ 
                    datosCargados: true, 
                    enfermedades1: datosRespuesta.data, 
                    pagina: datosRespuesta.total, 
                    ultimo: datosRespuesta.last_page, 
                    actual: datosRespuesta.current_page 
                });
            })
            .catch(console.log);
    }
    
    seleccionarEnfermedad = (codigo, descripcion) => {
        if (this.props.onSelect) {
            this.props.onSelect(codigo, descripcion);
        }
    }
    
    cerrarModal = () => {
        if (this.props.onClose) {
            this.props.onClose();
        }
    }
    
    render() {
        const { datosCargados, enfermedades1, pagina, ultimo, actual } = this.state;
        
        if (!datosCargados) {
            var load = 'Cargando datos....';
        } else {
            var load = '';
        }
        
        return (
            <div className="card">
                <div style={{ backgroundImage: 'linear-gradient(#2FB3FB, #003153)', color: '#FFFFFF', borderTopLeftRadius: 5, borderTopRightRadius: 5 }} className="card-header text-center">
                    <h5 style={{ fontSize: 18 }} >Lista de Enfermedades</h5>
                </div>
                <div className='card-body'>
                    <div className="row">
                        <div className="col-xl-5">
                            <input type="text" id="bdescripcion1" name="bdescripcion1" placeholder="Descripción" className="form-control form-control-sm" />
                        </div>
                        <div className="col-xl-3">
                            <input type="text" id="bcodigo1" name="bcodigo1" placeholder="Código" className="form-control form-control-sm" />
                        </div>
                        <div className="col-xl-4">
                            <button type="button" className="btn btn-primary btn-sm" onClick={() => this.BuscarEnf2(1)}>
                                <FontAwesomeIcon icon={faSearch} />&nbsp;&nbsp;Buscar
                            </button>&nbsp;&nbsp;
                            <button type="button" className="btn btn-danger btn-sm" onClick={() => this.resetForm()}>
                                <FontAwesomeIcon icon={faTimes} />&nbsp;&nbsp;Cancelar
                            </button>
                        </div>
                    </div>
                    <br></br>
                    <div className="row">
                        <table className="table table-hover table-condensed table-sm">
                            <thead className="thead-inverse">
                                <tr>
                                    <th>CÓDIGO</th>
                                    <th>DESCRIPCIÓN</th>
                                    <th>SEXO</th>
                                    <th>LIM. INFERIOR</th>
                                    <th>LIM. SUPERIOR</th>
                                    <th>SELECCIONAR</th>
                                </tr>
                            </thead>
                            <tbody>
                                {load}
                                {enfermedades1.map((itemEnfermedad1) => (
                                    <tr key={itemEnfermedad1.id_enfermedad}>
                                        <td>{itemEnfermedad1.codigo_enf}</td>
                                        <td>{itemEnfermedad1.descripcion}</td>
                                        <td>{itemEnfermedad1.sexo}</td>
                                        <td>{itemEnfermedad1.lim_inf}</td>
                                        <td>{itemEnfermedad1.lim_sup}</td>
                                        <td>
                                            <div className="btn-group" role="group" aria-label="">
                                                <button 
                                                    type="button" 
                                                    className="btn btn-primary btn-sm" 
                                                    onClick={() => this.seleccionarEnfermedad(itemEnfermedad1.codigo_enf, itemEnfermedad1.descripcion)}
                                                >
                                                    <FontAwesomeIcon icon={faArrowRight} />
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    <div className="row">
                        <div className='col-xs-12'>
                            <nav aria-label="Page navigation example">
                                <ul className="pagination">
                                    <li className="page-item">
                                        <button className="page-link" onClick={() => this.BuscarEnf2(1)}>
                                            <FontAwesomeIcon icon={faAngleDoubleLeft} />
                                        </button>
                                    </li>
                                    <li className="page-item">
                                        <button className="page-link" onClick={() => this.BuscarEnf2(actual - 1)}>
                                            <FontAwesomeIcon icon={faAngleLeft} />
                                        </button>
                                    </li>
                                    <li className="page-item">
                                        <button className="page-link" onClick={() => this.BuscarEnf2(actual)}>
                                            {actual}
                                        </button>
                                    </li>
                                    <li className="page-item">
                                        <button className="page-link" onClick={() => this.BuscarEnf2(actual + 1)}>
                                            <FontAwesomeIcon icon={faAngleRight} />
                                        </button>
                                    </li>
                                    <li className="page-item">
                                        <button className="page-link" onClick={() => this.BuscarEnf2(ultimo)}>
                                            <FontAwesomeIcon icon={faAngleDoubleRight} />
                                        </button>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                        <div className="card-footer text-muted">
                            <b>Pagina</b> <span className="badge bg-primary">{actual}</span> <b>de</b> <span className="badge bg-primary">{ultimo}</span> | <b>Registros</b> <span className="badge bg-success">{pagina}</span>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Enfermedades1;